module.exports = __webpack_public_path__ + "img/Butterfly_00341.de82abba.png";